import { ButtonProps, Button } from "@mantine/core"
import { forwardRef } from "react"

export const QualifyButton = forwardRef<HTMLAnchorElement, ButtonProps<"a">>(
  ({ sx, ...props }, ref) => (
    <Button
      ref={ref}
      component="a"
      radius={0}
      size="lg"
      color="cyan"
      sx={{ textTransform: "uppercase", zIndex: 10, ...sx }}
      {...props}
    >
      Do I qualify?
    </Button>
  )
)

QualifyButton.displayName = "QualifyingButton"
